<template lang="pug">
.checkboxComponent(
  :class="checkboxClasses",
  @click="onInput"
)
  .box
    .checkmark(v-if="isDecorative ? value : !!modelValue")
      .icon
        ui-svg-icon(name="checkmark")
  .label(
    v-if="labelText"
    :class="labelClasses"
  )
    ui-svg-icon(
      :name="withIcon"
      :size="iconSize"
    )
    .labelText {{ labelText }}
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: null
    },
    labelText: {
      type: String,
      default: ''
    },
    isDisabled: Boolean,
    isDecorative: Boolean,
    value: Boolean,
    labelClasses: {
      type: [Array, String],
      default: ''
    },
    iconSize: {
      type: Number,
      default: 16
    },
    withIcon: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  computed: {
    checkboxClasses () {
      return {
        _checked: this.isDecorative ? this.value : !!this.modelValue
      }
    }
  },
  methods: {
    onInput () {
      if (!this.isDisabled && !this.isDecorative) this.$emit('update:modelValue', !this.modelValue)
    }
  }
}
</script>

<style lang="sass" scoped>
.checkboxComponent
  display: flex
  align-items: center
  cursor: pointer

  > .box
    width: 7*$u
    height: 7*$u
    flex: 0 0 7*$u
    border: 0.75*$u solid $cElements
    border-radius: 2*$u
    background-color: transparent
    box-shadow: 0 $u $cDarkBackground

    > .checkmark
      height: 100%
      color: $cWhite
      padding: 0.75*$u
      .icon
        width: 4.25*$u
        height: 4*$u

  > .label
    color: $cBlack
    margin-left: 0.5em
    user-select: none
    display: flex
    align-items: center
    @include font('t16-regular')
    > .labelText
      margin-left: $u
    &._blue
      color: $cBlue

  @media(hover)
    &:hover
      > .box
        border-color: $cLightBlue
      > .label
        color: $cLightBlue

  &._checked
    > .box
      border-color: $cDarkBlue
      background-color: $cDarkBlue
      box-shadow: 0 $u $cShadowBlue
    > .label
      color: $cDarkBlue
    @media(hover)
      &:hover
        > .box
          border-color: $cLightBlue
          background-color: $cLightBlue
          box-shadow: 0 $u $cBlue
        > .label
          color: $cBlue
</style>
